<template>
	<div class="chat-message">
		<!--		<template v-for="(item, key) in messageGroups">-->
		<!--			<span v-if="item.tag === '<text>'" :key="key">-->
		<!--				{{ getDecodedMessage(item.message) }}-->
		<!--			</span>-->
		<!--			<a v-else-if="item.tag === '<a>'" :href="item.message">{{ getDecodedMessage(item.message) }}</a>-->
		<!--			<br v-else-if="item.tag === '<br>'">-->
		<!--		</template>-->
		<!-- <span v-html="decodedText"></span> -->
		<div
			@click="e => openImagePopup(e, item)"
			v-for="item in messages"
			:key="item.id"
			:class="{
				delivered:
					!delivered &&
					(authRole === 'admin' || authRole === 'manager')
			}"
		>
			<span v-if="item.tag === '<text>'" v-html="item.message"></span>
			<span class="file-container" v-if="item.tag === '<a>'">
				<a class="file-container__file" target="_blank" :href="item.message">
					{{ item.message }}
				</a>
				<button
					:disabled="item.isSended === 1"
					v-if="showButton && collocutor.role === undefined"
					@click="$emit('sendFile', item)"
					class="file-container__add__btn"
				>
					+
				</button>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "MessageBody",
	props: {
		text: {
			required: true,
			type: Object
		},
		collocutor: {
			type: Object,
			default: null
		}
	},

	computed: {
		authRole() {
			return this.$store.state.auth.role;
		},
		messageGroups() {
			return this.getMessageGroups();
		},
		decodedText() {
			return this.getDecodedMessage(this.message);
		},
		showButton() {
			if (this.authRole === "admin" || this.authRole === "manager")
				return true;
			return false;
		},
		delivered() {
			return this.text.delivered;
		},
		messages() {
			const message = this.text.message;
			let arr = [];
			if (message) {
				arr.push({
					tag: "<text>",
					message: message
				});
			}
			(this.text.files || []).map(el => {
				arr.push({
					tag: "<a>",
					message: el.file,
					id: el.id,
					isSended: el.attached
				});
			});
			return arr;
		}
	},

	methods: {
		openImagePopup(e, item) {
			this.$emit("openImagePopup", e, item);
		},
		cutMessage(message) {
			if (message.length > 60) {
				message = message.substr(0, 60) + "...";
			}
			return message;
		},
		getDecodedMessage(message) {
			return message;
			// return decodeURI(message);
		},
		addText(groups, message, start, length) {
			const text = message.substr(start, length);
			if (text.length !== 0) {
				return groups.push({
					tag: "<text>",
					message: text
				});
			}
		},
		addLink(groups, message, tag, start, length) {
			groups.push({
				tag,
				message: message.substr(start, length)
			});
		},
		addBreak(groups, tag) {
			groups.push({ tag });
		},
		getMessageGroups() {
			const message = this.text.message;
			let groups = [];
			let start = 0;
			let end = 0;

			while (true) {
				start = message.indexOf("<", start);
				if (start === -1) break;

				this.addText(groups, message, end, start - end);

				end = message.indexOf(">", start) + 1;
				const tag = message.substr(start, end - start);

				if (tag === "<br>") {
					this.addBreak(groups, tag);
				} else if (tag === "<a>") {
					start = end;
					end = message.indexOf("</a>", end);
					this.addLink(groups, message, tag, start, end - start);
					end += 4;
				}

				start = end;
			}

			const last = message.lastIndexOf(">") + 1;
			this.addText(groups, message, last);

			return groups;
		}
	}
};
</script>

<style lang="scss" scoped>
.chat-message {
	word-break: break-word;
	hyphens: auto;

	.delivered {
		background: rgba(255, 171, 93, 0.55);
		border-radius: 10px;
		padding: 5px;
    // display: flex;
    // align-items: flex-start;

    .icon {
      padding-left: 10px;
    }
	}

	.file-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 10px;

		&__file {
			width: 90%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;

			&:hover {
				white-space: normal;
			}
		}

		&__add__btn {
			height: 30px;
			padding: 0 10px;
			border: none;
			border-radius: 40%;
			background: #3ac47d;
			cursor: pointer;
			transition: all ease 0.3s;
			color: white;

			&:hover {
				background: #258352;
			}

			&:disabled {
				background: #3ac47d6c;
				cursor: default;
			}
		}
	}
}
</style>
